import _ from "lodash";
export const state = () => ({
  home: null,
  languagesAndCountries: null,
  videoPopupModal: false,
  videoPopupData: {},
  currentLanguage: "text_en",
  news: null,
  newsName: null,
  singleNews: {},
  events: null,
  socialWall: [],
  upComingEvents: [],
  singleEvent: {},
  getFilterItems: [],
  currentCountry: "GLOBAL",
  filteredMediaSearch: {},
  trade: null,
  featuredStories: {
    featured: [],
    tea_inspired: [],
    purpose: [],
    dilmah_conservation: [],
    sustainability: [],
    mjf_foundation: [],
  },
  productsAndInfutions: [],
  images: [],
  audios: [],
  videos: [],
  teaRanges: [],
  giftOfTea: [],
  products: [],
  isMobile: false,
  windowWidth: 0,
  globalSearchResult: null,

  // type: "featured"
});
export const getters = {
  countries: (state) => {},
};

export const mutations = {
  SET_LANGUAGE_AND_COUNTRIES(state, data) {
    state.languagesAndCountries = data;
  },
  SET_VIDEO_POPUP_MODAL(state, data) {
    state.videoPopupModal = data;
  },
  SET_VIDEO_POPUP_DATA(state, data) {
    state.videoPopupData = data;
  },
  SET_HOME(state, data) {
    state.home = data;
  },
  SET_NEWS(state, data) {
    state.news = data;
  },
  CLEAR_NEWS_RESULT(state) {
    state.news = null;
  },
  GET_SINGLE_NEWS(state, data) {
    state.singleNews = data;
  },
  CLEAR_SINGLE_NEWS(state) {
    state.singleNews = null;
  },
  SET_EVENTS(state, data) {
    state.events = data;
  },

  CLEAR_EVENTS_RESULT(state) {
    state.events = null;
  },
  SET_UP_COMING_EVENTS(state, data) {
    state.upComingEvents = data;
  },
  GET_SINGLE_EVENT(state, data) {
    state.singleEvent = data;
  },

  CLEAR_SINGLE_EVENT(state) {
    state.singleEvent = null;
  },
  SET_FEATURED_STORIES(state, data) {
    state.featuredStories[data.type] = data.data;
  },
  SET_IMAGES(state, data) {
    state.images = data;
  },
  SET_AUDIOS(state, data) {
    state.audios = data;
  },
  SET_VIDEOS(state, data) {
    state.videos = data;
  },
  SET_TEA_RANGES(state, data) {
    state.teaRanges = data;
  },
  SET_GIFT_OF_TEA(state, data) {
    state.giftOfTea = data;
  },
  SET_PRODUCTS(state, data) {
    state.products = data;
  },
  SET_PRODUCTS_AND_INFUSIONS(state, data) {
    state.productsAndInfutions = data;
  },
  SET_SOCIAL_WALL(state, data) {
    state.socialWall = data;
  },
  SET_MOBILE_STATE(state, data) {
    state.isMobile = data;
  },
  SET_WINDOW_WIDTH(state, data) {
    state.windowWidth = data;
  },
  GET_SEARCH_FILTER_ITEMS(state, data) {
    state.getFilterItems = data;
  },
  SET_GLOBAL_SEARCH_RESULT(state, data) {
    state.globalSearchResult = data;
  },
  CLEAR_GLOBAL_SEARCH_RESULT(state) {
    state.globalSearchResult = null;
  },
  GET_FILTERED_MEDIA_SEARCH(state, data) {
    state.filteredMediaSearch = data;
  },
  CLEAR_FILTERED_MEDIA_SEARCH(state) {
    state.filteredMediaSearch = {};
  },
  SET_TRADE(state, data) {
    state.trade = data;
  },
};

export const actions = {
  async gethomePage({ commit, state }) {
    const graphqlq = {
      query: `{
        homePages(where: { country: "${state.currentCountry}" }) {
          country
          page {
            sliders {
                slider_has_link
                link
              slider_has_video
              video_url
              image_url
              header {
                ${state.currentLanguage}
              }
            }
            mobile_sliders {
                slider_has_link
link
              slider_has_video
              video_url
              image_url
              header {
              ${state.currentLanguage}
               }
               }
            contents {
              has_header
              has_link
              link
              header {
                ${state.currentLanguage}
              }
              content {
                ${state.currentLanguage}
              }
              link_text {
                ${state.currentLanguage}
              }
              image_url
            }
            explore_dilmah_items{
              image_url
              title{
                ${state.currentLanguage}
              }
              link
            }
            
            featured_videos{
              image_url
              video_url
              header{
                ${state.currentLanguage}
              }
              description{
                ${state.currentLanguage}
              }
            }
          }
        }
      }`,
    };

    await this.$axios.$post("/graphql", graphqlq).then((response) => {
      commit("SET_HOME", response.data.homePages[0]);
      //$nuxt.$loading.finish();
    });
  },
  async getLanguagesAndCountries({ commit }) {
    await this.$axios.$get("languages-and-countries").then((response) => {
      commit("SET_LANGUAGE_AND_COUNTRIES", response);
    });
  },
  getNews: _.debounce(async function({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/news?page=${payload.page}&size=${payload.size}&year=${payload.year}&month=${payload.month}&subCategory=${payload.subCategory}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_NEWS", response);
      });
  }, 500),
  // getNews: _.debounce(async function({ commit, state }, payload) {
  //   await this.$axios
  //     .$get(
  //       `dmc-apis/news_by_name?page=${payload.page}&size=${payload.size}&year=${payload.year}&month=${payload.month}&subCategory=${payload.subCategory}&lang=${state.currentLanguage}`
  //     )
  //     .then((response) => {
  //       commit("SET_NEWS", response);
  //     });
  // }, 500),
  // async getSingleNewsById({ commit, state }, payload) {
  //   await this.$axios
  //     .$get(`dmc-apis/news_by_id/${payload.id}`)
  //     .then((response) => {
  //       commit("GET_SINGLE_NEWS", response);
  //     });
  // },
  async getSingleNewsById({ commit, state }, id) {
    await this.$axios
      .$get(`dmc-apis/news_by_name/${id}`)
      .then((response) => {
        console.log(response);
        commit("GET_SINGLE_NEWS", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getEvents: _.debounce(async function({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/events?page=${payload.page}&size=${payload.size}&year=${payload.year}&month=${payload.month}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_EVENTS", response);
      });
  }, 500),
  getUpComingEvents: _.debounce(async function({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/upcoming_events?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_UP_COMING_EVENTS", response);
      });
  }, 500),
  // async getSingleEventById({ commit, state }, payload) {
  //   await this.$axios
  //     .$get(`dmc-apis/event_by_id/${payload.id}`)
  //     .then((response) => {
  //       commit("GET_SINGLE_EVENT", response);
  //     });
  // },
  async getSingleEventById({ commit, state }, id) {
    await this.$axios.$get(`dmc-apis/event_by_name/${id}`).then((response) => {
      commit("GET_SINGLE_EVENT", response);
    });
  },

  async getFeaturedStories({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/featured_stories?lang=${state.currentLanguage}&type=${payload.type}&page=${payload.page}&size=${payload.size}&isMedia=1`
      )
      .then((response) => {
        commit("SET_FEATURED_STORIES", { data: response, type: payload.type });
      });
  },
  async getProductsAndInfutions({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/productsAndInfusions?lang=${state.currentLanguage}&page=${payload.page}&size=${payload.size}`
      )
      .then((response) => {
        commit("SET_PRODUCTS_AND_INFUSIONS", response.data);
      });
  },
  async getImages({ commit, state }, payload = { page: 1, size: 20 }) {
    await this.$axios
      .$get(
        `dmc-apis/images?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_IMAGES", response);
      });
  },
  async getAudios({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/audio?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_AUDIOS", response);
      });
  },
  async getVideos({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/video?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_VIDEOS", response.data);
      });
  },
  async getTeaRanges({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/tea_ranges?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_TEA_RANGES", response);
      });
  },
  async getGiftOfTea({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/gift_of_teas?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_GIFT_OF_TEA", response);
      });
  },
  async getProducts({ commit, state }, payload) {
    await this.$axios
      .$get(
        `dmc-apis/products?page=${payload.page}&size=${payload.size}&lang=${state.currentLanguage}`
      )
      .then((response) => {
        commit("SET_PRODUCTS", response);
      });
  },
  async getSocailWall({ commit, state }) {
    const graphqlq = {
      query: `{
        socialWallPages(where: { country: "${state.currentCountry}" }) {
          country
          page {
            social_wall_items{
              id
              image_url
              description{
                  text_en
              }
              icon_type
              link
            }
          }
        }
      }`,
    };

    await this.$axios.$post("/graphql", graphqlq).then((response) => {
      commit(
        "SET_SOCIAL_WALL",
        response.data.socialWallPages[0].page.social_wall_items
      );
    });
  },
  filterSearch: _.debounce(async function({ commit, state }, payload) {
    if (payload.filteredText.length > 0) {
      await this.$axios
        .$get(
          `dmc-apis/search_items?page=${payload.page}&size=${payload.size}&searchType=${payload.linkFolder}&searchTerm=${payload.filteredText}`
        )
        .then((response) => {
          commit("GET_SEARCH_FILTER_ITEMS", response);
        });
    }
  }, 2000),
  async globalSearch({ commit, state }, payload) {
    await this.$axios
      .$get(`dmc-apis/general_search?keyword=${payload}`)
      .then((response) => {
        commit("SET_GLOBAL_SEARCH_RESULT", response.data);
      });
  },
  mediaFilterSearch: _.debounce(async function({ commit, state }, payload) {
    if (payload.searchedText.length > 0) {
      await this.$axios
        .$get(`dmc-apis/media_search?keyword=${payload.searchedText}&lang=en`)
        .then((response) => {
          commit("GET_FILTERED_MEDIA_SEARCH", response.data);
        });
    }
  }, 2000),
  async newsletterSubscription({ commit }, { vm, data }) {
    await this.$axios.$post(`/dmc-apis/newsletter_subscription`, data).then(
      (response) => {
        if (response.success) {
          vm.settingActive = false;
          vm.$bvToast.toast("Subscribed successfully!", {
            title: `Success`,
            variant: "success",
            solid: true,
          });
          // vm.email = ''
        }
      },
      (error) => {
        vm.settingActive = false;
        // vm.$bvToast.toast(`${error.response.data.message.message}`, {
        vm.$bvToast.toast(`Email already exists`, {
          title: `Error`,
          variant: "danger",
          solid: true,
        });
      }
    );
  },
  async getTrade({ commit, state }) {
    const graphqlq = {
      query: `{
        dilmahTradePages(where: { country: "GLOBAL" }) {
        id
        country
        page{
          id
          title{
            text_en
          }
          banner_image_url
          our_product{
            id
            banner_image_url
            our_products_items{
              id
              image_url
              header_image_url
              title{
                text_en
              }
              description{
                text_en
              }
              title_text
              link
            }
          }
          header_content{
            id
            has_header
            has_link
            link
            header{
              text_en
            }
            content{
              text_en
            }
            link_text{
              text_en
            }
            image_url
            sub_heading{
              text_en
            }
            has_sub_heading
            has_video
            video_url
          }
          premium_retailers{
            id
            header_description{
              text_en
            }
            items{
              id
              image_url
              header_image_url
              title{
                text_en
              }
              description{
                text_en
              }
              title_text
              link
            }
          }
          fine_food_and_gourmet{
            id
            header_description{
              text_en
            }
            items{
              id
              image_url
              header_image_url
              title{
                text_en
              }
              description{
                text_en
              }
              title_text
              link
            }
          }
          high_quality_casual_dining{
            id
            header_description{
              text_en
            }
            items{
              id
              image_url
              header_image_url
              title{
                text_en
              }
              description{
                text_en
              }
              title_text
              link
            }
          }
          fine_dining{
            id
            header_description{
              text_en
            }
            items{
              id
              image_url
              header_image_url
              title{
                text_en
              }
              description{
                text_en
              }
              title_text
              link
            }
          }
       }
    }}`,
    };
    await this.$axios.$post("/graphql", graphqlq).then((response) => {
      commit("SET_TRADE", response.data.dilmahTradePages[0]);
    });
  },
};
